import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import lifecycle from 'recompose/lifecycle';

const withWindowHeight = compose(
  withState('windowHeight', 'setWindowHeight', window.innerHeight),
  withHandlers({
    updateWindowHeight: props => () => props.setWindowHeight(window.innerHeight),
  }),
  lifecycle({
    componentDidMount() {
      window.addEventListener('resize', this.props.updateWindowHeight);
    },

    componentWillUnmount() {
      window.removeEventListener('resize', this.props.updateWindowHeight);
    },
  }),
);
export default withWindowHeight;
